import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { ListPartnershipsInput } from '../domain/dtos/list-parnerships-input'
import { ListPartnershipsResponse } from '../domain/dtos/list-partnerships-response'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class ListPartnerships {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: ListPartnershipsInput, signal?: AbortSignal): Promise<ListPartnershipsResponse> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_WEB_URL}/partners/list`,
      body: {
        pagination: {
          page: input.page,
          pageSize: input.pageSize,
          orderBy: input.orderBy,
          orderDirection: input.orderDirection,
        },
        filters: {
          search: input.filters.search,
          status: input.filters.status,
        },
      },
      signal,
    })

    if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
      return response.data
    }

    throw new GeneralError()
  }
}
